import { CONTENT_BLOCKS } from 'types/cms/enums'
import { ContentBlockModel } from 'types/cms/components'
import { stringify } from 'qs'

/**
 * calculates the font-size based on the amount of characters
 *
 * @param {string} quote
 * @returns string
 */
export const getQuoteFontSize = (quote: string): string => {
  if (quote.length > 200) {
    return '18px'
  }

  if (quote.length < 50) {
    return '28px'
  }

  return '24px'
}

/**
 * creates the url of the video
 * @param {ContentBlockModel<typeof CONTENT_BLOCKS.VIMEO>} block
 * @returns string
 */
export const setVimeoUrl = (block: ContentBlockModel<typeof CONTENT_BLOCKS.VIMEO>): string => {
  const hasParams = block.autoplay || block.loop
  const url = block.url.split('?')[0]

  const query = stringify(
    {
      autoplay: block.autoplay ? 1 : null,
      loop: block.loop ? 1 : null,
      muted: block.autoplay ? 1 : null
    },
    { skipNulls: true }
  )

  return !hasParams ? url : `${url}?${query}`
}
